import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import preview from "./left-star.png"
import './dictionary.css';

const Dictionary = () => {
  const navigate = useNavigate();
  const [isDarkMode] = useState(true);

  // Apply dark mode to entire document
  useEffect(() => {
    const applyDarkMode = () => {
      if (isDarkMode) {
        document.documentElement.classList.add('dark-mode');
        document.body.classList.add('dark-mode');
      } else {
        document.documentElement.classList.remove('dark-mode');
        document.body.classList.remove('dark-mode');
      }
    };
    
    applyDarkMode();
    const timer = setTimeout(applyDarkMode, 10);
    
    return () => clearTimeout(timer);
  }, [isDarkMode]);

  const pronounceWord = () => {
    if ('speechSynthesis' in window) {
      const utterance = new SpeechSynthesisUtterance('supernova');
      utterance.rate = 0.95;
      utterance.pitch = 1.0;
      utterance.volume = 0.9;
      window.speechSynthesis.speak(utterance);
    }
  };

  return (
    <div className={`dictionary-container ${isDarkMode ? 'dark' : 'light'}`}>
      <div className="dictionary-content">
        <div className="term-header">
          <div className="word-pronunciation">
            <h1 className="word" onClick={() => navigate('/main')} style={{ cursor: 'pointer' }}>
              <img className="logo-left" alt="logo-left-star" src={ preview }/>
              <span className="logo-super">Super</span>
              <span className="logo-space"></span>
              <span className="logo-italic">nova</span>
              <span className="logo-star">★</span>
            </h1>
            <span className="sound-button" onClick={pronounceWord}>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon>
                <path d="M15.54 8.46a5 5 0 0 1 0 7.07"></path>
                <path d="M19.07 4.93a10 10 0 0 1 0 14.14"></path>
              </svg>
            </span>
          </div>
          <div className="syllables">su·per·no·va</div>
          <div className="pronunciation">/ ˌsuː.pɚˈnoʊ.və /</div>
        </div>
        
        <div className="definition">
          <div className="term">noun</div>
          
          <div className="category">
            <div className="category-label">ASTRONOMY</div>
            <div className="definition-text">
              the explosion of a star in which the star may reach a maximum intrinsic luminosity one billion times that of the sun.
            </div>
          </div>
          
          <div className="category">
            <div className="category-label">LATIN</div>
            <div className="definition-text">
              from <i>super</i> ("above") + <i>nova</i> ("new")
            </div>
          </div>
          
          <div className="category">
            <div className="category-label">FINANCE</div>
            <div className="definition-text">
              the protocol defining the safest and highest-yielding synthetic dollar and bond. See <Link to="/main" className="link-how-it-works" style={{color: "#FF8C00"}}>how it works</Link>.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dictionary; 